export const SITE101_SIM_KARTY = "site101-sim-karty";
export const SITE101_RATES_MOBILE = "site101-rates-mobile";
export const SITE101_NOMERA = "site101-nomera";
